<template lang="html">
  <div id="navigationBar">
    <ul class="listButtons leftButtons">
      <router-link tag="button" to="/table" title="座席予約表を見る">
        <i class="icon-timeline"></i>
        <span class="explanationText">座席予約表を見る</span>
      </router-link>
      <router-link tag="button" to="/reservation_list" v-if="isAdmin" title="予約のリスト">
        <i class="icon-list"></i>
        <span class="explanationText">予約のリスト</span>
      </router-link>
      <router-link tag="button" to="/rescheduling" title="予約変更">
        <i class="icon-alarm"></i>
        <span class="explanationText">振替を依頼する</span>
      </router-link>
      <datepicker
        v-if="this.$route.path === '/table'"
        language="ja"
        :format="'yyyy年MM月dd日(D)'"
        :value="$store.state.curDate.toISOString()"
        :disabled="getDisableDays()"
        @selected="dateSelectHandler"
        style="display: inline-block; width: 140px;"></datepicker>
    </ul>

    <transition name="fade">
      <img v-if="!$store.state.spinning" src="../../assets/img/logo.png" class="kyushinjuku-logo">
    </transition>
      <spinner v-if="$store.state.spinning"
      :color="'white'" :size="'40px'" style="margin-top: 18px;"></spinner>
    <span class="headerButtons">
      <span v-if="$store.state.userInfo.user_type !== 'student'" class="school" @click="schoolChange">
        <a v-if="$store.state.userInfo.school_id === '1'" class="school_ike">池袋校</a>
        <a v-if="$store.state.userInfo.school_id === '2'" class="school_yoko">横浜校</a>
      </span>
      <span class="on_off" @click="showOnline">
        <a v-if="$store.state.showOnline" class="online">Online</a>
        <a v-if="!$store.state.showOnline" class="offline">Offline</a>
      </span>
      <!--
      <span id="onlineCheckBox" class="onlineCheckBox">
        <input type="checkbox" id="showOnline" name="showOnline" @click="showOnline"/>
        <label for="showOnline">オンライン授業表示</label>
      </span>
      -->
    </span>
    <ul class="listButtons rightButtons">
      <router-link tag="button" to="/help" title="ヘルプ">
        <i class="icon-question-sign"></i>
        <span class="explanationText">ヘルプ</span>
        </router-link>
      <router-link tag="button" to="/reservationlist" title="月末報告" v-if="isTeacher">
        <i class="icon-appointment-agenda"></i>
        <span class="explanationText">月末報告</span>
        </router-link>
      <router-link tag="button" to="/management" v-if="isAdmin" title="管理画面">
        <i class="icon-cog"></i>
        <span class="explanationText">管理画面</span>
        </router-link>
      <router-link tag="button" to="/userinfo" title="ユーザー情報">
        <i class="icon-user"></i>
        <span class="explanationText">ユーザー情報</span>
        </router-link>
      <button title="ログアウト"
        @click="beforeLogout">
        <i class="icon-exit"></i>
        <span class="explanationText">ログアウト</span>
      </button>
    </ul>
    <div id="bottomline">
    </div>
  </div>
</template>

<script>
import DatePicker from 'vuejs-datepicker'
import spinner from 'vue-loading-spinner/src/components/Pencil.vue'
import {
  TIMETABLE_CHANGE_DATE,
  CHANGE_SCHOOL,
  SHOW_ONLINE
} from '@/vuex/mutation_types'
import {
  mapActions,
  mapGetters
} from 'vuex'

export default {
  data () {
    return {
      hover: ''
    }
  },
  components: {
    'datepicker': DatePicker,
    'spinner': spinner
  },
  computed: {
    ...mapGetters([
      'getCurDateFormated'
    ]),
    isAdmin () {
      if (this.$store.state.userInfo.user_type) {
        return this.$store.state.userInfo.user_type === 'admin'
      }
      return false
    },
    isTeacher () {
      if (this.$store.state.userInfo.user_type) {
        return this.$store.state.userInfo.user_type === 'teacher'
      }
      return false
    }
  },
  methods: {
    ...mapActions([
      'getReservations',
      'getClassrooms'
    ]),
    dateSelectHandler (payload) {
      this.$store.commit(TIMETABLE_CHANGE_DATE, {
        date: payload
      })
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      })
    },
    beforeLogout () {
      let isYes = confirm('ログアウトします．よろしいでしょうか．')
      if (isYes) {
        this.$router.push('/logout')
      }
    },
    getDisableDays () {
      let ddays = {
        days: [0]
      }
      if (this.$store.state.userInfo.is_Sunday_user === true) {
        return {days: []}
      } else {
        return ddays
      }
    },
    schoolChange () {
      if (this.$store.state.userInfo.school_id === '1') {
        this.$store.commit(CHANGE_SCHOOL, '2')
        this.getClassrooms(this.$store.state.userInfo.school_id)
        this.getReservations({
          all: 1,
          date: this.getCurDateFormated,
          school_id: this.$store.state.userInfo.school_id
        })
      } else {
        this.$store.commit(CHANGE_SCHOOL, '1')
        this.getClassrooms(this.$store.state.userInfo.school_id)
        this.getReservations({
          all: 1,
          date: this.getCurDateFormated,
          school_id: this.$store.state.userInfo.school_id
        })
      }
    },
    showOnline (event) {
      this.$store.commit(SHOW_ONLINE, event.target.classList.contains('offline'))
      console.log(this.$store.state.showOnline)
      this.getReservations({
        all: 1,
        date: this.getCurDateFormated,
        school_id: this.$store.state.userInfo.school_id
      })
    }
  }
}
</script>

<style lang="css" scoped>
div#navigationBar {
  position: fixed;  /* 画面上部に固定 */
  box-sizing: border-box;

  width: 100%;
  height: 46px;
  max-height: 80px;
  min-height: 30px;
  margin: 0;
  background-color: #ffd500;

  z-index: 9999;
}
ul.listButtons {
  height: 100%;
  padding-left: 0px;
}
.listButtons>button {
  height: 100%;

  border-style: solid;
  border-color: transparent;

  font-size: 18px;
  font-weight: bold;
  color: white;
  background-color: #ffd500;

  text-shadow: #888 1px 1px 0px, #888 -1px 1px 0px,
              #888 1px -1px 0px, #888 -1px -1px 0px;
}
.listButtons>button:hover {
  border-width: 2px;
  background-color: #0065B3;
  text-shadow: none;

}
ul.leftButtons {
  float: left;
}
ul.rightButtons {
  float: right;
}
.router-link-exact-active.currentLink {
  background-color: #0065B3;
  text-shadow: none;
}
/* 画面が小さいサイズの時に説明文を消す */
@media screen and (max-width: 920px) {
   .explanationText {
     display: none;
   }
}

#bottomline{
  display: block;
  position: absolute;
  width: 100%;
  float: none;
  border: none;
  padding: 0;
  top: 46px;
  height: 1px;
  border-top: solid 2px #E69200;
  background: none;
  border-bottom: none;
}

/* ロゴ用のCSS */
.kyushinjuku-logo {
  display: inline-block;
  background: white;
  height: 46px;
  shadow: #888 1px 1px 0px, #888 -1px 1px 0px,
              #888 1px -1px 0px, #888 -1px -1px 0px;
}
.fade-enter-active {
  transition: opacity .5s
}
.fade-leave-active {
  transition: opacity 0s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
.school{
  position: absolute;
  margin: 10px;
  top: -8px;
}
.school_ike{
  background-color: rgb(68, 105, 187);
  border-radius: 5px;
  color: rgb(255, 255, 255);
}
.school_yoko{
  background-color: rgb(47, 171, 9);
  border-radius: 5px;
  color: rgb(255, 255, 255);
}
.on_off{
  position: absolute;
  margin: 10px;
  top: 12px; /*どうしても場所が合わないのでとりあえず*/
}
.online{
  background-color: rgb(25, 25, 25);
  border-radius: 5px;
  color: rgb(255, 255, 255);
}
.offline{
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  color: rgb(0, 0, 0);
}
.onlineCheckBox label {
  white-space: pre-wrap; /* 改行を保持しつつ、テキストを折り返す */
}

</style>



// WEBPACK FOOTER //
// AppHeader.vue?007c971a